import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined, MobileOutlined } from '@ant-design/icons';
import { Link, useHistory } from 'react-router-dom';
import {
  isMobile,
} from 'react-device-detect';
import { EmailRegxValidator } from '../../utils';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { CreateAccountInfluencer } from '../../apis/CreateAccount';
import { dispatch } from '../../store/state';

const { useForm } = Form;
export const InfluencerSignupFormComponent = () => {
  const history = useHistory();
  const [InfluencerSignupForm] = useForm();
  const [apiValidation, setApiValidation] = useState({
    success: false,
    points: [],
  });
  const onFinish = (values) => {
    console.log('Received values of form: ', values);
    const _data = values;
    delete _data.termagree; // @note: removing non required in endpoint
    if (apiValidation.error) {
      setApiValidation({
        success: false,
        points: [],
      });
    }

    // @note: creating a new account
    CreateAccountInfluencer(_data).then(({ response, status }) =>{
      if (status === 200) {
        setApiValidation({
          success: true,
          points: [],
        });
        dispatch({
          type: 'SET_USER',
          payload: {
            ...response,
            phone: _data.phone,
            email: _data.email,
          },
        });
        setTimeout(() => {
          console.log('Ready to redirect otp');
          InfluencerSignupForm.resetFields();
          history.push('/influencer/validate-otp');
        }, 200);
      } else {
        const _msgs = [];
        response.errors.forEach((error) => {
          _msgs.push(error.msg);
          return null;
        });
        setApiValidation({
          success: false,
          points: _msgs,
          // points: ["Signup Blocked for this user"]
        });
      }
    });
  };

  return (
    <div>
      <Form
        form={InfluencerSignupForm}
        name="InfluencerSignupForm"
        className="login-form"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
      >
        <Form.Item
          name="firstname"
          rules={[
            {
              required: true,
              message: 'Please provide your First Name!',
            },
          ]}
        >
          <Input
            className="common_input"
            size={isMobile ? 'large': ''}
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="First Name" />
        </Form.Item>

        <Form.Item
          name="lastname"
          rules={[
            {
              required: true,
              message: 'Please provide your Last Name!',
            },
          ]}
        >
          <Input
            className="common_input"
            // size="large"
            size={isMobile ? 'large': ''}
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Last Name" />
        </Form.Item>

        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please provide your Email ID!' },
            () =>({
              validator (_, value) {
                if (value && !EmailRegxValidator(value)) {
                  return Promise.reject(new Error('Please provide a valid Email ID'));
                } else {
                  return Promise.resolve();
                }
              },
            }),
          ]}
        >
          <Input
            type="email"
            className="common_input"
            // size="large"
            size={isMobile ? 'large': ''}
            prefix={<MailOutlined className="site-form-item-icon" />}
            placeholder="Email Address" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            { required: true, message: 'Please input your Password!' },
            { min: 6, message: 'Minimum password length 6' },
          ]}
        >
          <Input
            className="common_input"
            // size="large"
            size={isMobile ? 'large': ''}
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              message: 'Please provide your Mobile Number!',
            },
          ]}
        >
          <Input
            type="tel"
            className="common_input"
            size={isMobile ? 'large': ''}
            // size="large"
            prefix={<MobileOutlined className="site-form-item-icon" />}
            placeholder="Mobile Number" />
        </Form.Item>

        <Form.Item name="termagree"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value ? Promise.resolve() : Promise.reject(new Error('Should accept terms')),
            },
          ]}
        >
          <Checkbox>Accepting our <a href="https://flynt.social/terms-and-conditions.php"
            target="_blank"
            rel='noreferrer'>Terms &amp; Conditions</a> and <a href='https://flynt.social/privacy.php'
            target="_blank"
            rel='noreferrer'>Policy</a></Checkbox>

        </Form.Item>

        <Form.Item>
          <Button type="primary"
            htmlType="submit"
            className="common_button px-2">
                    Create Account
          </Button>
          <div className="d-block d-md-none"></div>
          <span className="pl-2">Already having account? </span>
          <Link to="/signin"><Button className="px-0"
            type="link">SignIn</Button></Link>
        </Form.Item>

        {
          apiValidation.points.length ?
            <div>
              <p className="text-danger mb-1"><strong>Failed to created Account due to following reasons:</strong></p>
              <ul className="pl-3">
                {apiValidation.points.map((point, index) =>(
                  <li key={index}
                    className="text-danger">{point}</li>
                ))}
              </ul>
            </div> :
            null
        }
        {apiValidation.success && <h6 className="text-success mb-1">Account created successfully!</h6>}
      </Form>
    </div>
  );
};
